import { Check, Circle } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/landing/primitives";
import { ROADMAP } from "@/data/content";

export default function Roadmap() {
  return (
    <section id="roadmap" className="relative py-20 md:py-28 scroll-mt-24" data-testid="section-roadmap">
      <div className="container-trt">
        <SectionHeading
          eyebrow="Roadmap"
          title="The path to a global"
          highlight="RWA network"
          sub="A phased rollout — from testnet foundation to a worldwide tokenized RWA marketplace."
        />

        <div className="mt-16 grid md:grid-cols-4 gap-5 relative">
          <div className="hidden md:block absolute top-6 left-0 right-0 h-px gold-line" />
          {ROADMAP.map((phase, i) => (
            <Reveal key={phase.q} delay={i * 0.12}>
              <div className="relative">
                <div className="flex items-center gap-3 mb-5">
                  <span className={`relative z-10 w-12 h-12 rounded-full flex items-center justify-center ${phase.done ? "glass-gold gold-glow" : "glass"}`}>
                    {phase.done ? <Check className="w-5 h-5 text-[var(--gold-2)]" /> : <Circle className="w-4 h-4 text-[var(--muted)]" />}
                  </span>
                </div>
                <div className="glass rounded-2xl p-5 card-hover h-full">
                  <div className="text-[10px] font-mono uppercase tracking-widest text-[var(--gold-2)]">{phase.q}</div>
                  <h3 className="font-display text-lg font-bold mt-1">{phase.title}</h3>
                  <ul className="mt-4 space-y-2">
                    {phase.items.map((it) => (
                      <li key={it} className="flex items-start gap-2 text-sm text-[var(--muted)]">
                        <span className={`mt-1.5 w-1.5 h-1.5 rounded-full shrink-0 ${phase.done ? "bg-[var(--emerald)]" : "bg-[var(--gold-3)]"}`} />
                        {it}
                      </li>
                    ))}
                  </ul>
                  <div className={`mt-4 text-[10px] font-mono uppercase tracking-widest ${phase.done ? "text-[var(--emerald)]" : "text-[var(--muted)]"}`}>
                    {phase.done ? "● Completed" : "○ In progress"}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
